import { LangfuseWeb } from 'langfuse';

import { getEnv } from '../utilities/env';
import { logError } from '../datadog/logger';

let langfuseInstance: LangfuseWeb | null = null;

const getLangfuseClient = (): LangfuseWeb => {
    if (!langfuseInstance) {
        const publicKey = getEnv('LANGFUSE_PUBLIC_KEY');
        const baseUrl = getEnv('LANGFUSE_BASE_URL');
        if (!publicKey) {
            throw new Error('[Langfuse] LANGFUSE_PUBLIC_KEY environment variable is not defined');
        }
        if (!baseUrl) {
            throw new Error('[Langfuse] LANGFUSE_BASE_URL environment variable is not defined');
        }

        langfuseInstance = new LangfuseWeb({ publicKey, baseUrl });
    }

    return langfuseInstance;
};

export const sendFeedbackScore = async (
    traceId: string,
    value: 1 | 0,
    comment?: string,
    metadata?: {
        dossier_id?: string;
        agent_id?: number;
        agency_id?: number;
    },
): Promise<void> => {
    try {
        const langfuse = getLangfuseClient();

        await langfuse.score({
            traceId,
            name: 'user_feedback',
            value,
            ...(comment && { comment: comment.trim() }),
            ...(metadata && { metadata }),
        });
    } catch (error) {
        logError('[Langfuse] Failed to send feedback score', { error, traceId });
    }
};
